import { Form, Input, Modal } from "antd";
import { get } from "immutable";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { ARTWORK } from "../../../types";

const TemplateName = ({ template, onCancel = () => {}, workspace }) => {
  const { artwork } = workspace;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({
      title: get(artwork, `templates[${template}].title`),
    });
  }, [template]);
  const handleOnChange = (values) => {
    dispatch({
      type: ARTWORK.SET,
      payload: {
        ...artwork,
        templates: artwork.templates.map((tpl, index) =>
          index === template ? { ...tpl, ...values } : tpl
        ),
      },
    });
    onCancel();
  };
  return (
    <Modal
      visible={template !== null}
      onOk={() => form.submit()}
      onCancel={onCancel}
      title="Template title"
    >
      <Form form={form} layout="vertical" onFinish={handleOnChange}>
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(TemplateName);
